__webpack_require__.p = "/abdullahs-terminal/";